import Badge from '@anm/components/Badge';
import { BreadcrumbWrapper } from '@anm/components/Breadcrumbs/Wrapper';
import DropDownBreadcrumbWrapper from '@anm/components/DropDownBreadcrumb/Wrapper';
import Tooltip from '@anm/components/Tooltip';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const breadcrumbWrapperMobile = media.tablet`
  margin: 0;
`;

export const CustomizationBreadcrumbWrapper = styled.div`
  width: 100%;
  ${DropDownBreadcrumbWrapper} {
    padding: 0;
    ${BreadcrumbWrapper} {
      ${breadcrumbWrapperMobile};
    }
  }
`;

export const BreadcrumbBadge = styled(Badge)`
  padding: 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
  box-shadow: none;
  margin-left: 10px;
  border-radius: 4px;
  margin: 0 0 0 10px;
  background-color: #fff4db;
  &:before {
    margin: 0;
    width: 12px;
    height: 12px;
  }
`;

export const TooltipWrapper = styled(Tooltip)`
  padding: 12px 20px 14px;
  min-width: 230px;
  right: -7px;
  top: calc(100% + 14px);
  &:before {
    right: 10px;
    left: auto;
    border-width: 0 9px 10px 9px;
  }
`;
